import { PngAboutuspage } from "../../assets";
import flavors from "../../assets/flavors.json";
import { useEffect } from "react";
import { useState } from "react";
import Footer from "../../components/Footer";

export default function Products() {
  const [query, setQuery] = useState("");
  const [filteredFlavors, setFilteredFlavors] = useState(flavors);

  useEffect(() => {
    setFilteredFlavors(
      flavors.filter((flavor) =>
        flavor.toLowerCase().includes(query.toLowerCase()),
      ),
    );
  }, [query]);

  return (
    <>
      <section className="about__hero">
        <img
          loading="lazy"
          className="about__hero__img"
          src={PngAboutuspage}
          alt=" At AFF, we pioneer evocative aromas and tastes that inspire and endure. As an ambitious trailblazer in Asia, we envision a world where every Scent tells a story, and every Flavor is a journey AdvancedFF, a leader in global Flavors & Fragrances, offers cutting-edge aromatic solutions, bespoke scents, and innovative flavor creations. With a commitment to excellence, our natural extracts, culinary aromas, and custom fragrance formulations redefine sensory experiences. Explore our diverse range of gourmet essences, aroma compounds, and unique fragrances crafted with expertise. From scent marketing to personalized aromatics, our top-rated flavor and fragrance design elevate culinary sensations. AdvancedFF sets the standard in fragrance trends, delivering premium scents, bespoke flavoring, and unparalleled fragrance diversity. Experience the artistry of AdvancedFF, where advanced technology meets olfactory mastery for a world-class sensory journey ,AdvancedFF, a leader in global Flavors & Fragrances, offers cutting-edge aromatic solutions, bespoke scents, and innovative flavor creations. With a commitment to excellence, our natural extracts, culinary aromas, and custom fragrance formulations redefine sensory experiences. Explore our diverse range of gourmet essences, aroma compounds, and unique fragrances crafted with expertise. From scent marketing to personalized aromatics, our top-rated flavor and fragrance design elevate culinary sensations. AdvancedFF sets the standard in fragrance trends, delivering premium scents, bespoke flavoring, and unparalleled fragrance diversity. Experience the artistry of AdvancedFF, where advanced technology meets olfactory mastery for a world-class sensory journey,advancedffwebsite aff  aff website   advancedff advancedff.com advancedff advancedff advancedgg advancedff
advancedgg affwebsite  Advanced Flavors & Fragrances Pte. Ltd.
Advanced Flavors & Fragrances Pte. Ltd.
Advanced Flavors and  Flavors & Fragrances Pte. Ltd.
advnacedff   flavour flavour singapore advancedff-Image Containg Buildings"
        />
        <div className="about__hero__content">
          <div className="about__hero__content__heading">Products </div>
          <input
            type="text"
            className="about__hero__content__input"
            placeholder="Search Flavors"
            value={query}
            style={{
              width: "100%",
              maxWidth: "500px",
              padding: "0em 1rem",
              height: "3rem",
              border: "none",
              outline: "none",
              borderRadius: "5px",
              fontSize: "1.2rem",
            }}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      </section>
      <section className="Productssection">
        <div className="Productssection__content">
          {filteredFlavors.length === 0 ? (
            <div
              className="Productssection__content__name"
              style={{
                width: 300,
              }}
            >
              No Flavors Found
            </div>
          ) : (
            filteredFlavors.map((flavor, index) => (
              <div
                key={flavor + index}
                className="Productssection__content__name"
                style={{
                  backgroundImage: `url("https://picsum.photos/seed/${flavor}/200/300/?blur")`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  position: "relative",
                  borderRadius: "20px",
                  height: "150px",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    bottom: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0,0,0,0.7)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "white",
                    fontSize: "1.2rem",
                    padding: "1rem",
                    fontWeight: "bold",
                    borderRadius: "20px",
                  }}
                >
                  {flavor}
                </div>
              </div>
            ))
          )}
        </div>
      </section>
      <Footer />
    </>
  );
}
